// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1299":"4e5ae01a","2346":"f8835319","5967":"d015fac8"}[chunkId] + ".chunk.css";
};